<template>
  <div id="app">
    <Loading v-show="LOADING"></Loading>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loading from "@/components/Loading.vue";
import VConsole from "vconsole";
export default {
  computed: {
    ...mapState(["LOADING"])
  },
  name: "App",
  components: { Loading },
  created() {
    const mode = process.env.NODE_ENV;
    if (mode == "test") {
      new VConsole();
    }
  },
  methods: {}
};
</script>

<style>
* {
  border: 0;
  padding: 0;
  margin: 0;
}
#app {
  /* background: #EBECEF; */
  min-height: 100vh;
}
</style>
